import { createLazyFileRoute } from '@tanstack/react-router';

import { DefaultLayout } from '@src/layout';
import { IndustryDetail } from '@src/pages/Industries';

export const Route = createLazyFileRoute('/industries/financial')({
  component: FinancialIndustryPage,
});

function FinancialIndustryPage() {
  return (
    <DefaultLayout>
      <IndustryDetail industryId="financial" />
    </DefaultLayout>
  );
}
